// Cache duration configuration (in milliseconds)
export const CACHE_DURATIONS = {
  // Authentication - cache for entire session
  USER_INFO: 60 * 60 * 1000, // 1 hour
  AUTH_CHECK: 30 * 60 * 1000, // 30 minutes

  // Employee data - moderate cache
  EMPLOYEES: 10 * 60 * 1000, // 10 minutes
  DEPARTMENTS: 15 * 60 * 1000, // 15 minutes
  ROLES: 15 * 60 * 1000, // 15 minutes
  EMPLOYEE_DETAILS: 10 * 60 * 1000, // 10 minutes

  // Leave data - shorter cache (frequent updates)
  LEAVES: 5 * 60 * 1000, // 5 minutes
  LEAVE_TYPES: 30 * 60 * 1000, // 30 minutes (static)
  LEAVE_SUMMARY: 5 * 60 * 1000, // 5 minutes
  LEAVE_REQUESTS: 5 * 60 * 1000, // 5 minutes

  // Attendance - very short cache (updates frequently)
  ATTENDANCE: 3 * 60 * 1000, // 3 minutes
  ATTENDANCE_STATS: 3 * 60 * 1000, // 3 minutes

  // Static data - long cache
  HOLIDAYS: null, // Until invalidated
  LEAVE_TYPE_LIST: 30 * 60 * 1000, // 30 minutes

  // Transient data - short cache
  NOTIFICATIONS: 2 * 60 * 1000, // 2 minutes
  STATS: 5 * 60 * 1000, // 5 minutes
  DOCUMENTS: 10 * 60 * 1000, // 10 minutes
  BIRTHDAY_ANNIVERSARY: 60 * 60 * 1000, // 1 hour

  // Other
  FORM_OPTIONS: 30 * 60 * 1000, // 30 minutes
  RESIGNED_EMPLOYEES: 10 * 60 * 1000, // 10 minutes
  ENCASHMENTS: 5 * 60 * 1000, // 5 minutes
};

// Determine cache duration from URL
export function getCacheDurationForUrl(url) {
  const urlLower = url.toLowerCase();

  if (urlLower.includes("/userinfo") || urlLower.includes("/getuserinfo"))
    return CACHE_DURATIONS.USER_INFO;
  if (urlLower.includes("/employees") && !urlLower.includes("/add"))
    return CACHE_DURATIONS.EMPLOYEES;
  if (urlLower.includes("/departments")) return CACHE_DURATIONS.DEPARTMENTS;
  if (urlLower.includes("/roles")) return CACHE_DURATIONS.ROLES;
  if (urlLower.includes("/leave") && !urlLower.includes("/type"))
    return CACHE_DURATIONS.LEAVES;
  if (urlLower.includes("/leavetype")) return CACHE_DURATIONS.LEAVE_TYPES;
  if (urlLower.includes("/attendance") && !urlLower.includes("/stats"))
    return CACHE_DURATIONS.ATTENDANCE;
  if (urlLower.includes("/attendance/stats"))
    return CACHE_DURATIONS.ATTENDANCE_STATS;
  if (urlLower.includes("/holiday")) return CACHE_DURATIONS.HOLIDAYS;
  if (urlLower.includes("/notification")) return CACHE_DURATIONS.NOTIFICATIONS;
  if (urlLower.includes("/document")) return CACHE_DURATIONS.DOCUMENTS;
  if (urlLower.includes("/stat")) return CACHE_DURATIONS.STATS;
  if (urlLower.includes("/birthday") || urlLower.includes("/anniversary"))
    return CACHE_DURATIONS.BIRTHDAY_ANNIVERSARY;
  if (urlLower.includes("/encashment")) return CACHE_DURATIONS.ENCASHMENTS;
  if (urlLower.includes("/option")) return CACHE_DURATIONS.FORM_OPTIONS;

  // Default: 5 minutes
  return 5 * 60 * 1000;
}

// URL patterns that should NOT be cached
export const NO_CACHE_PATTERNS = [
  "/logout",
  "/upload",
  "/submit",
  "/create",
  "/update",
  "/delete",
];

export function shouldCache(method, url) {
  // Only cache GET requests
  if (method?.toUpperCase() !== "GET") return false;

  // Don't cache certain patterns
  return !NO_CACHE_PATTERNS.some((pattern) =>
    url.toLowerCase().includes(pattern.toLowerCase()),
  );
}
